export const NAME = 'lastRemoteProofs';
